import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/client'
import { ThemeProvider } from 'styled-components'
import * as Sentry from '@sentry/browser'
import theme from './theme'
import './theme/index.css'
import App from './components/App'
import * as serviceWorker from './serviceWorker'
import apolloClient from './apollo/client'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
})

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </ApolloProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
